import React from 'react'
import useSmallScreens from '@probatix/common/hooks/useSmallScreens'

import NotFoundView from './NotFound.view'

const NotFoundContainer = () => {
  const [, isMobile, isSmallDesktop] = useSmallScreens()

  return (
    <div data-testid="not-found">
      <NotFoundView
        isMobile={isMobile}
        isSmallDesktop={isSmallDesktop}
      />
    </div>
  )
}

export default NotFoundContainer
